import { HEADERS } from ".";

export const REPORTS_API = {
  getAllReport: () => ({
    endPoint: '/api/v1/report/all',
    headers: HEADERS.TOKEN_HEADER,
    method: 'GET',
  }),
  getReportsByProfileId: (id) => ({
    endPoint: `/api/v1/report/${id}/list`,
    headers: HEADERS.TOKEN_HEADER,
    method: "GET",
  }),
  insertReport: () => ({
    endPoint: "/api/v1/report/create",
    headers: HEADERS.TOKEN_HEADER,
    method: "POST",
  }),
  updateReport: () => ({
    endPoint: "/api/v1/report/update",
    headers: HEADERS.TOKEN_HEADER,
    method: "PUT",
  }),
  deleteReport: (id) => ({
    endPoint: `/api/v1/report/delete/${id}`,
    headers: HEADERS.TOKEN_HEADER,
    method: "DELETE",
  }),
  updateReportAccepted: () => ({
		endPoint: '/api/v1/formSciReport/updateScore_Accepted',
    headers: HEADERS.TOKEN_HEADER,
    method: 'PUT',
  }),
  // Nối 1 liên kết vào hồ sơ ngay khi Thêm - không cần bấm Lưu bản nháp.
  linkReportToForm: () => ({
    endPoint: '/api/v1/formSciReport/addOne',
    headers: HEADERS.TOKEN_HEADER,
    method: 'POST',
  }),
};

export const REPORTS_TYPE = {
  GET_ALL_REPORT_LOADING: 'GET_ALL_REPORT_LOADING',
  GET_ALL_REPORT_SUCCESS: 'GET_ALL_REPORT_SUCCESS',
  GET_ALL_REPORT_FAILURE: 'GET_ALL_REPORT_FAILURE',

  GET_REPORTS_BY_PROFILE_ID_LOADING: "GET_REPORTS_BY_PROFILE_ID_LOADING",
  GET_REPORTS_BY_PROFILE_ID_SUCCESS: "GET_REPORTS_BY_PROFILE_ID_SUCCESS",
  GET_REPORTS_BY_PROFILE_ID_FAILURE: "GET_REPORTS_BY_PROFILE_ID_FAILURE",

  INSERT_REPORTS_LOADING: "INSERT_REPORTS_LOADING",
  INSERT_REPORTS_SUCCESS: "INSERT_REPORTS_SUCCESS",
  INSERT_REPORTS_FAILURE: "INSERT_REPORTS_FAILURE",

  UPDATE_REPORT_LOADING: "UPDATE_REPORT_LOADING",
  UPDATE_REPORT_SUCCESS: "UPDATE_REPORT_SUCCESS",
  UPDATE_REPORT_FAILURE: "UPDATE_REPORT_FAILURE",

  DELETE_REPORT_LOADING: "DELETE_REPORT_LOADING",
  DELETE_REPORT_SUCCESS: "DELETE_REPORT_SUCCESS",
  DELETE_REPORT_FAILURE: "DELETE_REPORT_FAILURE",

  UPDATE_REPORT_ACCEPTED_LOADING: 'UPDATE_REPORT_ACCEPTED_LOADING',
  UPDATE_REPORT_ACCEPTED_SUCCESS: 'UPDATE_REPORT_ACCEPTED_SUCCESS',
  UPDATE_REPORT_ACCEPTED_FAILURE: 'UPDATE_REPORT_ACCEPTED_FAILURE',
};

// QCV 2026 (bảng điểm mục 3): Hội thảo quốc tế Q1/Q2, Oral xuất sắc, Poster xuất sắc.
// Danh sách hội thảo/hội nghị uy tín áp dụng theo quy định HĐ GSNN và Quỹ Nafosted.
const typeOptions = {
  international: [
		{ key: 'q1', title: 'Báo cáo khoa học đăng trên hội thảo quốc tế Q1', value: 'q1' },
		{ key: 'q2', title: 'Báo cáo khoa học đăng trên hội thảo quốc tế Q2', value: 'q2' },
		{ key: 'q3', title: 'Báo cáo khoa học đăng trên hội thảo quốc tế Q3', value: 'q3' },
		{ key: 'q4', title: 'Báo cáo khoa học đăng trên hội thảo quốc tế Q4', value: 'q4' },
  ],
  // QCV 2026: hội thảo chỉ tính 4 phân loại quốc tế (Q1, Q2, Oral, Poster).
  // (Giữ lại - không xóa) phân loại "trong nước" cũ, đã bỏ khỏi danh sách xét
  // cho hồ sơ MỚI (BaoCaoForm ưu tiên getQcvScoreOptions mục 3 khi có cấu
  // hình), nhưng vẫn cần giữ ở đây để cột Phân loại của hồ sơ CŨ (đã lưu các
  // giá trị này) không hiện trắng dù DB vẫn có dữ liệu.
  domestic: [
		{ key: 'b3', title: 'Hội thảo quốc gia', value: 'b3' },
		{ key: 'b2-1', title: 'Poster xuất sắc', value: 'b2-1' },
		{ key: 'b2-2', title: 'Báo cáo trên hội thảo, không được giải', value: 'b2-2' },
  ],
}

export const REPORTS_CONSTANTS = {
  TYPE_OPTIONS : {
    ALL: [...typeOptions.international, ...typeOptions.domestic],
    DOMESTIC: typeOptions.domestic,
    INTERNATIONAL: typeOptions.international,
  },
  ROLE_OPTIONS :[
		{ key: 'main', title: 'Tác giả chính (Tác giả đầu, tác giả liên hệ)', value: 'main' },
    { key: 'member', title: 'Đồng tác giả', value: 'member' },
	]
}